import React from 'react';
import { Switch, IconButton, Icon } from '@monash/portal-react';
import c from './page-item.module.scss';

const PageItem = ({
  id,
  pageName,
  hiddenPages,
  setHiddenPages,
  index,
  totalPages,
  onMoveUp,
  onMoveDown,
}) => {
  const isPageHidden = hiddenPages?.includes(id);

  const screenReaderLabel = `${isPageHidden ? 'Show' : 'Hide'} ${pageName}`;

  const hidePage = () => {
    setHiddenPages((f) => [...f, id]);
  };

  const showPage = () => {
    setHiddenPages((f) => {
      const index = hiddenPages?.indexOf(id);
      const newHiddenPages = [...f];
      if (index > -1) {
        newHiddenPages.splice(index, 1);
      }
      return newHiddenPages;
    });
  };

  const isFirstPage = index === 0;
  const isLastPage = index === totalPages - 1;

  return (
    <div className={c.pageItem}>
      {pageName}
      <div className={c.controls}>
        <IconButton
          icon={Icon.ArrowUp}
          ariaLabel={`Move ${pageName} up`}
          onClick={onMoveUp}
          disabled={isFirstPage}
          className={c.reorderArrows}
        />

        <IconButton
          icon={Icon.ArrowDown}
          ariaLabel={`Move ${pageName} down`}
          onClick={onMoveDown}
          disabled={isLastPage}
          className={c.reorderArrows}
        />

        <Switch
          on={!isPageHidden}
          ariaLabel={screenReaderLabel}
          onClick={isPageHidden ? showPage : hidePage}
        />
      </div>
    </div>
  );
};

export default PageItem;
